export enum CallPriorityEnum {
  veryHight = 'veryHight',
  hight = 'hight',
  low = 'low',
  neutral = 'neutral',
}
